import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Progress, ProgressDto, ProgressValue, ProgressValueDto } from '../models';
import { map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private readonly httpClient = inject(HttpClient);

    getProgress(): Observable<Progress[]> {
        return this.httpClient.get<ProgressDto[]>('api/v1/progress').pipe(map((dtos) => dtos.map((dto) => new Progress(dto))));
    }

    markLessonAsCompleted(value: ProgressValue) {
        const dto = new ProgressValueDto(value, true);
        return this.httpClient.post<unknown>('api/v1/progress', dto);
    }

    markLessonAsUncompleted(value: ProgressValue) {
        const dto = new ProgressValueDto(value, false);
        return this.httpClient.post<unknown>('api/v1/progress', dto);
    }
}
